export const useOnConfirmButtonClick = () => {
  return () => {
    console.log('confirm button clicked')
  }
}
